import React from 'react'
import View from '../../../../../components/pdf/View'
import { Col } from '../../../../../components/pdf/Grid'
import TableResults from './sections/TableResults'
import Header from '../../_shared/Header'

const Resultados = ({ headerValues, diagSegValues }) => {
  headerValues = {
    tipo: 'CHECKLIST - DIAGNÓSTICO DE SEGURANÇA',
    titulo: 'RESULTADO FINAL',
    ...headerValues
  }

  return (
    <View
      pageBreakAfter
      style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
    >
      <Col>
        <Header headerValues={headerValues} category={'RESULTADO FINAL'} />
      </Col>
      <Col
        flex={1}
        style={{
          border: '1px solid #333',
          borderTop: 'none',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem 1.5rem'
        }}
      >
        <TableResults diagSegValues={diagSegValues} />
      </Col>
    </View>
  )
}

export default Resultados
